/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the mass percent column?`)
};

const es_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es la columna de porcentaje de masa?`)
};

const de_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist die Massenprozent-Spalte?`)
};

const nl_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is de massapercentagekolom?`)
};

const fr_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que la colonne pourcentage de masse ?`)
};

const it_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è la colonna della percentuale di massa?`)
};

const pt_br2_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a coluna de percentual de massa?`)
};

const pt_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é a coluna de percentagem de massa?`)
};

const ja_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`質量パーセントの列は何を示していますか？`)
};

const zh_mw_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`质量百分比列是什么？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_faq_q3", locale)
	if (locale === "en") return en_mw_faq_q3(inputs)
	if (locale === "es") return es_mw_faq_q3(inputs)
	if (locale === "de") return de_mw_faq_q3(inputs)
	if (locale === "nl") return nl_mw_faq_q3(inputs)
	if (locale === "fr") return fr_mw_faq_q3(inputs)
	if (locale === "it") return it_mw_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_mw_faq_q3(inputs)
	if (locale === "pt") return pt_mw_faq_q3(inputs)
	if (locale === "ja") return ja_mw_faq_q3(inputs)
	return zh_mw_faq_q3(inputs)
};